import { Alert } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { formatDateLocal } from "@/lib/dates";
import { useAppState } from "@/store/useApp";
import { Download, ExternalLink } from "lucide-react";
import { useState } from "react";
import { useApi } from "@/hooks/use-api";
import { FeedbackFormatDialog } from "@/features/documents/FeedbackFormatDialog";
import { useFeature } from "@/hooks/use-feature";

const FeedbackPublishedAlert = () => {
  const grading = useAppState((state) => state.grading);
  const currentDocument = useAppState((state) => state.currentDocument);
  const isPublishingFeedback = useAppState((state) => state.isPublishingFeedback);
  const { exportFeedback } = useApi();
  const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);
  const feedbackExportEnabled = useFeature("feedbackExport");
  
  const documentId = currentDocument?.id;
  const isPublishingCurrentDocument = isPublishingFeedback;

  if (!grading || grading.feedback?.status !== "published") {
    return null;
  }

  const handleDownloadFeedback = () => {
    setFeedbackDialogOpen(true);
  };

  return (
    <>
      {documentId && (
        <FeedbackFormatDialog
          open={feedbackDialogOpen}
          onOpenChange={setFeedbackDialogOpen}
          documentId={documentId}
          exportFeedback={exportFeedback}
        />
      )}
      <Alert className="mb-2">
        <ExternalLink className="h-4 w-4" />
        <div className="flex align-center justify-between">
          <div>
            <span>Student report has been published</span>
            <div className="text-muted-foreground text-sm mt-1">
              You published this report on {formatDateLocal(grading?.feedback?.publishedAt)}.
            </div>
          </div>
          {feedbackExportEnabled && (
            <div className="mt-2">
              <Button
                size="sm"
                onClick={handleDownloadFeedback}
                className="self-end"
                disabled={!documentId || isPublishingCurrentDocument}
              >
                <Download className="mr-2 h-4 w-4" />
                Download
              </Button>
            </div>
          )}
        </div>
      </Alert>
    </>
  );
};

export default FeedbackPublishedAlert;
